import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsAllPlanWorks(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_ALL_PLAN_WORKS,
		ModulesConfigMap[ModulesMap.REGULATIONS_ALL_PLAN_WORKS].GET_REGULATIONS_ALL_PLAN_WORKS,
		options
	)
}
export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_ALL_PLAN_WORKS].GET_REGULATIONS_ALL_PLAN_WORKS]: _getRegulationsAllPlanWorks,
}